import { Form } from 'antd';
import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import { SimulateLoanEntity } from 'domain/entities/SimulateEntity';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { CONSTANTS } from 'utilities/constants/SIMULATE';
import { commonHelpers } from 'utilities/helpers';

type props = {
    service: SimulateUseCaseInterface;
};
const ONE_BILLION = 1e9;
const FormSimulateSale = ({ service }: props) => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [btnDisable, setBtnDisable] = React.useState<boolean>(true);
    const initForm = async () => {
        try {
            dispatch(startFetching());
            const response = await service.getSimulateLoanDefaultValue();
            const data = response.result;
            const existingLoanAmount =
                data.existingLoanAmount || data.existingLoanAmount === 0
                    ? data.existingLoanAmount
                    : data.loanAmount;
            form.setFieldsValue({
                annualIncome: commonHelpers.formatNumberMoney(
                    data.annualIncome * 10000 < ONE_BILLION ? data.annualIncome * 10000 : ONE_BILLION - 1,
                ),
                existingLoanAmount:
                    existingLoanAmount * 10000 < ONE_BILLION
                        ? commonHelpers.formatNumberMoney(existingLoanAmount * 10000)
                        : commonHelpers.formatNumberMoney(ONE_BILLION - 1),
            });
            setBtnDisable(false);
        } catch (error: any) {
            /* empty */
        } finally {
            dispatch(completeFetching());
        }
    };
    useEffect(() => {
        initForm();
    }, []);
    const onChangeForm = () => {
        if (
            Object.values(form.getFieldsValue()).some(
                (item: any) => item === undefined || item === '',
            )
        )
            setBtnDisable(true);
        else setBtnDisable(false);
    };

    const replace = (value: string) => {
        return value.replaceAll(',', '');
    };

    const onSubmit = (values: any) => {
        const payload: SimulateLoanEntity = {
            annualIncome: Number(replace(values?.annualIncome)),
            existingLoanAmount: Number(replace(values?.existingLoanAmount)),
            simId: null,
        };
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_052_02}`, { state: payload });
        // eslint-disable-next-line no-empty
    };

    const itemRules = {
        annualIncome: [
            {
                required: true,
                message: getMessage('In_Required', '年収'),
            },
        ],
        existingLoanAmount: [
            {
                required: true,
                message: getMessage('In_Required', '既存借入額'),
            },
        ],
    };

    return (
        <div className="section-wrapper">
            <div className="simulate-form">
                <Form form={form} onFinish={onSubmit} onChange={onChangeForm}>
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <FormInput
                                placeholder={PLACEHOLDER.ANNUAL_INCOME}
                                type="number"
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="annualIncome"
                                maxLength={9}
                                min={0}
                                rules={itemRules.annualIncome}
                                label="年収"
                            />
                        </div>
                        <div className="simulate-form-input">
                            <FormInput
                                placeholder={PLACEHOLDER.EXISTING_LOAN_AMOUNT}
                                suffix={'円'}
                                type="number"
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="existingLoanAmount"
                                maxLength={9}
                                min={0}
                                rules={itemRules.existingLoanAmount}
                                label="既存借入額"
                            />
                        </div>
                    </div>

                    <div className="simulate-form-item">
                        <div
                            className="simulate-form-button"
                            style={{
                                cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
                                background: `${btnDisable ? '#D0D3D8' : '#4bcae5'}`,
                            }}
                            onClick={() => (!btnDisable ? form.submit() : null)}
                        >
                            実行
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default FormSimulateSale;
